module.exports = __webpack_public_path__ + "sitefinity.png?4c1d5a1b4082b1ad75833ccb58f0f1f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/sitefinity.png
// module id = 194
// module chunks = 0